window.SFCInit = window.SFCInit || function (root, cfg) {
var NS = 0, CX = 200;
var FABRICS = [
['nederland',   { fill: '#ffffff', line: '#3a3a36', stitch: '#8a8a8a', strap: '#2f2f2c', dark: false, flag: ['h', '#ae1c28', '#ffffff', '#21468b'] }],
['duitsland',   { fill: '#dd0000', line: '#1a1a18', stitch: '#8a8a8a', strap: '#2f2f2c', dark: true,  flag: ['h', '#000000', '#dd0000', '#ffce00'] }],
['frankrijk',   { fill: '#ffffff', line: '#3a3a36', stitch: '#8a8a8a', strap: '#2f2f2c', dark: false, flag: ['v', '#0055a4', '#ffffff', '#ef4135'] }],
['belgi',       { fill: '#fdda24', line: '#1a1a18', stitch: '#8a8a8a', strap: '#2f2f2c', dark: false, flag: ['v', '#000000', '#fdda24', '#ef3340'] }],
['oostenrijk',  { fill: '#ffffff', line: '#3a3a36', stitch: '#8a8a8a', strap: '#2f2f2c', dark: false, flag: ['h', '#ed2939', '#ffffff', '#ed2939'] }],
['itali',       { fill: '#ffffff', line: '#3a3a36', stitch: '#8a8a8a', strap: '#2f2f2c', dark: false, flag: ['v', '#009246', '#ffffff', '#ce2b37'] }],
['ruit',        { fill: '#f4f5f7', line: '#2b3f66', stitch: '#2b3f66', strap: '#e9ecf2', dark: false, pattern: 'ruit' }],
['denim zwart', { fill: '#2c2e35', line: '#0f1013', stitch: '#b9bcc6', strap: '#25272d', dark: true }],
['denim',       { fill: '#44618c', line: '#1f2f49', stitch: '#e7c58a', strap: '#3b557c', dark: true }],
['marine',      { fill: '#1e2b4d', line: '#0c1326', stitch: '#8d9bc4', strap: '#1a2543', dark: true }],
['kobalt',      { fill: '#2152c4', line: '#0f2b70', stitch: '#b5c8ff', strap: '#1c48ad', dark: true }],
['wit',         { fill: '#f6f4ee', line: '#6f6a5e', stitch: '#b9b3a4', strap: '#ebe8df', dark: false }],
['zwart',       { fill: '#25241f', line: '#080807', stitch: '#8f8b80', strap: '#1e1d19', dark: true }],
['bordeaux',    { fill: '#6e1b2b', line: '#350a13', stitch: '#d79aa6', strap: '#611726', dark: true }],
['rood',        { fill: '#c5272e', line: '#6d0f14', stitch: '#ffc2c4', strap: '#b02228', dark: true }],
['oranje',      { fill: '#ea7a1c', line: '#8a420a', stitch: '#ffe0bf', strap: '#d86d15', dark: false }],
['geel',        { fill: '#f3c623', line: '#8f6e06', stitch: '#8f6e06', strap: '#e4b815', dark: false }],
['bruin',       { fill: '#6c4629', line: '#32200f', stitch: '#d6b08d', strap: '#5f3d23', dark: true }],
['groen',       { fill: '#2f6b45', line: '#143321', stitch: '#b4dcc2', strap: '#295e3d', dark: true }],
['grijs',       { fill: '#8a8f97', line: '#44484e', stitch: '#e3e5e8', strap: '#7c8189', dark: false }],
['beige',       { fill: '#d9c7a6', line: '#7d6b49', stitch: '#7d6b49', strap: '#cdb992', dark: false }]
];
var FALLBACK = { fill: '#a9adb3', line: '#50545a', stitch: '#eceef0', strap: '#9a9ea5', dark: false };
function fabricFor(name) {
var k = String(name || '').toLowerCase();
for (var i = 0; i < FABRICS.length; i++) if (k.indexOf(FABRICS[i][0]) !== -1) return FABRICS[i][1];
return FALLBACK;
}
var SHAPES = {
'halter':       { bib: true,  bw: 120, ty: 96,  wy: 214, W: 250, by: 430 },
'halter-groot': { bib: true,  bw: 132, ty: 82,  wy: 206, W: 292, by: 466 },
'kinder':       { bib: true,  bw: 98,  ty: 150, wy: 242, W: 194, by: 402, noGroot: true },
'recht':        { bib: true,  bw: 150, ty: 92,  wy: 212, W: 268, by: 446, straight: true },
'afwas':        { bib: true,  bw: 142, ty: 76,  wy: 200, W: 300, by: 476, plain: true, min: 5 },
'sloof-kort':   { bib: false, wy: 190, W: 284, by: 330 },
'sloof-midden': { bib: false, wy: 170, W: 288, by: 392 },
'sloof-lang':   { bib: false, wy: 150, W: 290, by: 452 }
};
var CC = ['Wit', 'Zwart', 'Marine blauw', 'Kobalt blauw', 'Rood', 'Oranje', 'Geel', 'Bruin', 'Groen', 'Grijs'];
function guessShape(m) {
var k = (String(m.title || '') + ' ' + String(m.handle || '')).toLowerCase();
if (k.indexOf('sloof') !== -1 || k.indexOf('sloven') !== -1) {
if (k.indexOf('kort') !== -1 || k.indexOf('bakker') !== -1) return 'sloof-kort';
return k.indexOf('kok') !== -1 ? 'sloof-midden' : 'sloof-lang';
}
if (k.indexOf('kinder') !== -1) return 'kinder';
if (k.indexOf('afwas') !== -1) return 'afwas';
if (k.indexOf('vlag') !== -1) return 'recht';
if (k.indexOf('groot') !== -1) return 'halter-groot';
return 'halter';
}
function shapeOf(m) { return SHAPES[m.shape] ? m.shape : guessShape(m); }
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function n(v) { return Math.round(v * 10) / 10; }
function defsFor(f, id) {
var s = '';
if (f.flag) {
s += '<linearGradient id="' + id + 'p" x1="0" y1="0" x2="' + (f.flag[0] === 'v' ? 1 : 0) + '" y2="' + (f.flag[0] === 'v' ? 0 : 1) + '">' +
'<stop offset="0" stop-color="' + f.flag[1] + '"/><stop offset=".3333" stop-color="' + f.flag[1] + '"/>' +
'<stop offset=".3333" stop-color="' + f.flag[2] + '"/><stop offset=".6667" stop-color="' + f.flag[2] + '"/>' +
'<stop offset=".6667" stop-color="' + f.flag[3] + '"/><stop offset="1" stop-color="' + f.flag[3] + '"/></linearGradient>';
} else if (f.pattern === 'ruit') {
s += '<pattern id="' + id + 'p" width="16" height="16" patternUnits="userSpaceOnUse">' +
'<rect width="16" height="16" fill="' + f.fill + '"/>' +
'<rect width="8" height="16" fill="#2b4a86" opacity=".5"/>' +
'<rect width="16" height="8" fill="#2b4a86" opacity=".5"/></pattern>';
} else if (f.pattern === 'streep') {
s += '<pattern id="' + id + 'p" width="13" height="13" patternUnits="userSpaceOnUse">' +
'<rect width="13" height="13" fill="' + f.fill + '"/>' +
'<rect x="6" width="1.2" height="13" fill="#ffffff" opacity=".55"/></pattern>';
}
return s;
}
function paint(f, id) { return (f.pattern || f.flag) ? 'url(#' + id + 'p)' : f.fill; }
function pocket(x, y, w, h, fill, f) {
var c = 8;
if (f.flag) fill = 'none';
var d = 'M' + n(x) + ',' + n(y) + ' L' + n(x + w) + ',' + n(y) + ' L' + n(x + w) + ',' + n(y + h - c) +
' Q' + n(x + w) + ',' + n(y + h) + ' ' + n(x + w - c) + ',' + n(y + h) + ' L' + n(x + c) + ',' + n(y + h) +
' Q' + n(x) + ',' + n(y + h) + ' ' + n(x) + ',' + n(y + h - c) + ' Z';
return '<path d="' + d + '" fill="' + fill + '" stroke="' + f.line + '" stroke-width="2" stroke-linejoin="round"/>' +
'<path d="M' + n(x + 4) + ',' + n(y + 7) + ' L' + n(x + w - 4) + ',' + n(y + 7) + '" fill="none" stroke="' + f.stitch +
'" stroke-width="1.4" stroke-dasharray="4 3"/>';
}
function apronSVG(o) {
var S = SHAPES[o.shape] || SHAPES.halter, f = o.fabric, ex = o.extras || {};
if (ex.garen) {
f = { fill: f.fill, line: f.line, strap: f.strap, dark: f.dark, pattern: f.pattern, flag: f.flag, stitch: o.garenColor || (f.dark ? '#f5b82e' : '#d1432b') };
}
var id = 'sfc' + (cfg.id || '') + 'g' + (++NS);
var xl = CX - S.W / 2, xr = CX + S.W / 2, r = 16, wy = S.wy, by = S.by, ty = S.ty;
var bl = CX - (S.bw || 0) / 2, br = CX + (S.bw || 0) / 2;
var ink = f.dark ? '#f3efe6' : '#25231f', fill = paint(f, id), d, out = '';
var bottom = ' L' + xr + ',' + (by - r) + ' Q' + xr + ',' + by + ' ' + (xr - r) + ',' + by + ' L' + (xl + r) + ',' + by +
' Q' + xl + ',' + by + ' ' + xl + ',' + (by - r) + ' L' + xl + ',' + wy;
if (S.bib) {
d = 'M' + bl + ',' + ty + ' L' + br + ',' + ty;
if (S.straight) d += ' L' + br + ',' + (wy - 26) + ' Q' + br + ',' + wy + ' ' + (br + 26) + ',' + wy + ' L' + xr + ',' + wy;
else d += ' C' + br + ',' + n(ty + (wy - ty) * 0.6) + ' ' + n(xr - (xr - br) * 0.3) + ',' + (wy - 6) + ' ' + xr + ',' + wy;
d += bottom;
if (S.straight) d += ' L' + (bl - 26) + ',' + wy + ' Q' + bl + ',' + wy + ' ' + bl + ',' + (wy - 26) + ' Z';
else d += ' C' + n(xl + (bl - xl) * 0.3) + ',' + (wy - 6) + ' ' + bl + ',' + n(ty + (wy - ty) * 0.6) + ' ' + bl + ',' + ty + ' Z';
} else {
d = 'M' + xl + ',' + wy + ' L' + xr + ',' + wy + bottom + ' Z';
}
out += '<defs>' + defsFor(f, id) +
'<clipPath id="' + id + 'c"><path d="' + d + '"/></clipPath>' +
'<linearGradient id="' + id + 'g" x1="0" x2="1" y1="0" y2="0">' +
'<stop offset="0" stop-color="#ffffff" stop-opacity=".14"/><stop offset=".5" stop-color="#ffffff" stop-opacity="0"/>' +
'<stop offset="1" stop-color="#000000" stop-opacity=".14"/></linearGradient></defs>';
function band(pd, w) {
return '<path d="' + pd + '" fill="none" stroke="' + f.line + '" stroke-width="' + (w + 4) + '" stroke-linecap="round"/>' +
'<path d="' + pd + '" fill="none" stroke="' + f.strap + '" stroke-width="' + w + '" stroke-linecap="round"/>';
}
if (S.bib) {
var sh = Math.min(88, (ty - 8) / 0.75);
var P = [[bl + 10, ty + 6], [bl - 6, ty - sh], [br + 6, ty - sh], [br - 10, ty + 6]];
out += band('M' + P[0][0] + ',' + P[0][1] + ' C' + P[1][0] + ',' + n(P[1][1]) + ' ' + P[2][0] + ',' + n(P[2][1]) + ' ' + P[3][0] + ',' + P[3][1], 10);
if (ex.nekband) {
var t = 0.8, u = 1 - t;
var px = u * u * u * P[0][0] + 3 * u * u * t * P[1][0] + 3 * u * t * t * P[2][0] + t * t * t * P[3][0];
var py = u * u * u * P[0][1] + 3 * u * u * t * P[1][1] + 3 * u * t * t * P[2][1] + t * t * t * P[3][1];
var dx = 3 * u * u * (P[1][0] - P[0][0]) + 6 * u * t * (P[2][0] - P[1][0]) + 3 * t * t * (P[3][0] - P[2][0]);
var dy = 3 * u * u * (P[1][1] - P[0][1]) + 6 * u * t * (P[2][1] - P[1][1]) + 3 * t * t * (P[3][1] - P[2][1]);
var a = Math.atan2(dy, dx) * 180 / Math.PI;
out += '<g transform="translate(' + n(px) + ',' + n(py) + ') rotate(' + n(a) + ')">' +
'<rect x="-12" y="-11" width="24" height="22" rx="4" fill="none" stroke="#2a2925" stroke-width="7"/>' +
'<rect x="-12" y="-11" width="24" height="22" rx="4" fill="none" stroke="#d3ccba" stroke-width="3.6"/>' +
'<line x1="0" y1="-11" x2="0" y2="11" stroke="#d3ccba" stroke-width="3.2"/>' +
'<path d="M10,5 L30,9" fill="none" stroke="' + f.line + '" stroke-width="10" stroke-linecap="round"/>' +
'<path d="M10,5 L30,9" fill="none" stroke="' + f.strap + '" stroke-width="6.5" stroke-linecap="round"/></g>';
}
if (ex.drukknopen) {
[0.7, 0.79, 0.88].forEach(function (tt) {
var uu = 1 - tt;
var sx = uu * uu * uu * P[0][0] + 3 * uu * uu * tt * P[1][0] + 3 * uu * tt * tt * P[2][0] + tt * tt * tt * P[3][0];
var sy = uu * uu * uu * P[0][1] + 3 * uu * uu * tt * P[1][1] + 3 * uu * tt * tt * P[2][1] + tt * tt * tt * P[3][1];
out += '<circle cx="' + n(sx) + '" cy="' + n(sy) + '" r="4.4" fill="#d3ccba" stroke="#2a2925" stroke-width="1.6"/>';
});
}
}
var k = Math.min(55, xl - 12), tyy = wy + (S.bib ? 10 : 11);
out += band('M' + (xl + 6) + ',' + tyy + ' C' + n(xl - 0.8 * k) + ',' + (tyy - 6) + ' ' + n(xl - k) + ',' + (tyy + 40) + ' ' + n(xl - 0.6 * k) + ',' + (tyy + 84), 8);
out += band('M' + (xr - 6) + ',' + tyy + ' C' + n(xr + 0.8 * k) + ',' + (tyy - 6) + ' ' + n(xr + k) + ',' + (tyy + 40) + ' ' + n(xr + 0.6 * k) + ',' + (tyy + 84), 8);
out += '<path d="' + d + '" fill="' + fill + '"/>';
out += '<path d="' + d + '" fill="url(#' + id + 'g)"/>';
if (ex.baan) {
out += '<rect clip-path="url(#' + id + 'c)" x="' + n(xl + S.W * 0.1) + '" y="0" width="18" height="500" fill="' +
(o.baanColor || (f.fill === '#c5272e' ? '#1e2b4d' : '#c5272e')) + '"/>';
}
out += '<g clip-path="url(#' + id + 'c)" fill="none" stroke="' + f.stitch + '" stroke-width="1.5" stroke-dasharray="5 4">';
if (S.bib) out += '<path d="M' + bl + ',' + (ty + 11) + ' L' + br + ',' + (ty + 11) + '"/>';
else out += '<path d="M' + xl + ',' + (wy + 22) + ' L' + xr + ',' + (wy + 22) + '"/>';
out += '<path d="M' + xl + ',' + (by - 14) + ' L' + xr + ',' + (by - 14) + '"/></g>';
out += '<path d="' + d + '" fill="none" stroke="' + f.line + '" stroke-width="2.6" stroke-linejoin="round"/>';
var heup = null;
if (ex.heupzak || ex.heupzak3) {
var pw = S.W * 0.58, ph = Math.min(96, (by - wy) * 0.44), pyy = wy + Math.max(S.bib ? 30 : 40, (by - wy) * 0.26);
heup = { x: CX - pw / 2, y: pyy, w: pw, h: ph };
out += pocket(heup.x, heup.y, pw, ph, fill, f);
(ex.heupzak3 ? [heup.x + pw / 3, heup.x + pw * 2 / 3] : [CX]).forEach(function (vx) {
out += '<path d="M' + n(vx) + ',' + n(pyy) + ' L' + n(vx) + ',' + n(pyy + ph) + '" stroke="' + f.stitch + '" stroke-width="1.4" stroke-dasharray="4 3" fill="none"/>';
});
}
if (ex.zijzak) {
var zw = S.W * 0.26, zh = Math.min(66, (by - wy) * 0.28);
var zy = heup ? Math.min(heup.y + heup.h + 12, by - zh - 22) : wy + (S.bib ? 22 : 34);
out += pocket(xr - zw - 12, zy, zw, zh, fill, f);
}
if (ex.loopsplit) {
var sp = (by - wy) * 0.24;
out += '<path d="M' + (CX - 6) + ',' + by + ' L' + CX + ',' + n(by - sp) + ' L' + (CX + 6) + ',' + by + ' Z" fill="#000000" fill-opacity=".3" stroke="' + f.line + '" stroke-width="1.6" stroke-linejoin="round"/>' +
'<path d="M' + (CX - 8) + ',' + n(by - sp) + ' L' + (CX + 8) + ',' + n(by - sp) + '" stroke="' + f.stitch + '" stroke-width="2.4" stroke-linecap="round" fill="none"/>';
}
var chest = S.bib && (ex.borstzak || ex.pennenzak), cy = 0, ch = 0;
if (chest) {
var cw = S.bw * (ex.borstzak ? 0.34 : 0.2), cxp = CX + S.bw * 0.08;
cy = ty + (wy - ty) * 0.34; ch = S.bw * 0.34;
if (ex.pennenzak || ex.borstzak) {
var penx = cxp + cw - S.bw * 0.1;
out += '<path d="M' + n(penx) + ',' + n(cy - 15) + ' L' + n(penx) + ',' + n(cy + 8) + '" stroke="#e0a63a" stroke-width="4.5" stroke-linecap="round" fill="none"/>';
out += '<path d="M' + n(penx + 7) + ',' + n(cy - 10) + ' L' + n(penx + 7) + ',' + n(cy + 8) + '" stroke="#d94a3a" stroke-width="4.5" stroke-linecap="round" fill="none"/>';
}
out += pocket(cxp, cy, cw, ch, fill, f);
if (ex.pennenzak && ex.borstzak) {
var dvx = cxp + cw - S.bw * 0.16;
out += '<path d="M' + n(dvx) + ',' + n(cy) + ' L' + n(dvx) + ',' + n(cy + ch) + '" stroke="' + f.stitch + '" stroke-width="1.4" stroke-dasharray="4 3" fill="none"/>';
}
}
if (ex.logo) {
var lw, lcx, lcy, place = o.logoPlace || 'middel', vert = false, lo = '';
if (place === 'groot') {
vert = true; lw = (by - wy) * 0.46;
lcx = ex.zijzak ? xr - S.W * 0.26 - 34 : xr - S.W * 0.14; lcy = wy + (by - wy) * 0.58;
} else if (S.bib) {
if (place === 'klein') { lw = S.bw * 0.34; lcx = CX - S.bw * 0.2; lcy = ty + (wy - ty) * 0.42; }
else if (chest) { lw = S.bw * 0.4; lcx = CX - S.bw * 0.22; lcy = cy + ch / 2; }
else { lw = S.bw * 0.74; lcx = CX; lcy = ty + (wy - ty) * 0.46; }
} else if (place === 'klein') {
lw = S.W * 0.2; lcx = xl + S.W * 0.22; lcy = wy + 44;
} else {
lw = S.W * 0.42; lcx = CX; lcy = heup ? heup.y + heup.h / 2 + 4 : wy + (by - wy) * 0.5;
}
var gx = lcx, gy = lcy;
if (vert) { lcx = 0; lcy = 0; }
var txt = String(o.logoText || '').trim().slice(0, 28);
if (o.logoImg) {
var lh = vert ? 30 : lw * 0.6;
lo += '<image href="' + esc(o.logoImg) + '" x="' + n(lcx - lw / 2) + '" y="' + n(lcy - lh / 2) + '" width="' + n(lw) + '" height="' + n(lh) + '" preserveAspectRatio="xMidYMid meet"/>';
} else if (txt) {
var fs = Math.max(8, Math.min(24, lw / (txt.length * 0.56)));
var fit = txt.length * fs * 0.56 > lw ? ' textLength="' + n(lw) + '" lengthAdjust="spacingAndGlyphs"' : '';
lo += '<text x="' + n(lcx) + '" y="' + n(lcy) + '" text-anchor="middle" dominant-baseline="central" ' +
'font-family="Georgia, \'Times New Roman\', serif" font-style="italic" font-weight="700" font-size="' + n(fs) + '"' + fit +
' fill="' + ink + '" stroke="' + f.line + '" stroke-width=".4" paint-order="stroke">' + esc(txt) + '</text>';
} else {
lo += '<rect x="' + n(lcx - lw / 2) + '" y="' + n(lcy - 14) + '" width="' + n(lw) + '" height="28" rx="5" fill="' + f.fill +
'" fill-opacity=".85" stroke="' + ink + '" stroke-width="1.4" stroke-dasharray="4 3"/>' +
'<text x="' + n(lcx) + '" y="' + n(lcy) + '" text-anchor="middle" dominant-baseline="central" font-family="Arial, sans-serif" ' +
'font-weight="700" font-size="' + (lw < 56 ? 7 : 10) + '" letter-spacing="1" fill="' + ink + '">UW LOGO</text>';
}
out += vert ? '<g transform="translate(' + n(gx) + ',' + n(gy) + ') rotate(-90)">' + lo + '</g>' : lo;
}
return '<svg viewBox="0 0 400 500" xmlns="http://www.w3.org/2000/svg"' + (o.label ? ' role="img" aria-label="' + esc(o.label) + '"' : ' aria-hidden="true"') + '>' + out + '</svg>';
}
function swatchSVG(f) {
var id = 'sfc' + (cfg.id || '') + 's' + (++NS);
return '<svg viewBox="0 0 32 32" aria-hidden="true"><defs>' + defsFor(f, id) + '</defs>' +
'<circle cx="16" cy="16" r="14.5" fill="' + paint(f, id) + '" stroke="' + f.line + '" stroke-opacity=".45" stroke-width="1"/></svg>';
}
var extraVariantIds = {};
var extras = (cfg.extras || []).map(function (e, i) {
if (e.variantId) extraVariantIds[e.variantId] = 1;
return { i: i, title: e.title, text: e.text || '', effect: e.effect || 'geen', applies: e.applies || 'alle',
variantId: e.variantId || null, price: e.variantId ? (e.price || 0) : 0, priceLabel: e.priceLabel || '',
askText: !!e.askText, textLabel: e.textLabel || 'Toelichting', group: e.group || '', askFile: !!e.askFile,
fileLabel: e.fileLabel || 'Bestand', on: false, value: '', file: null, img: '', note: '', color: null };
});
var models = (cfg.models || []).filter(function (m) {
if (!m.variants || !m.variants.length) return false;
return !m.variants.some(function (v) { return extraVariantIds[v.id]; });
});
if (cfg.merge !== false) {
var byBase = {}, merged = [];
models.forEach(function (m) {
var base = String(m.title).split(' - ')[0].trim();
m.variants.forEach(function (v) { v.ptitle = m.title; });
if (byBase[base]) byBase[base].variants = byBase[base].variants.concat(m.variants);
else { byBase[base] = { title: base, handle: m.handle, shape: m.shape, variants: m.variants.slice() }; merged.push(byBase[base]); }
});
models = merged;
}
var logoSizes = [];
(cfg.logo || []).forEach(function (z) {
var steps = [];
(z.variants || []).forEach(function (v) {
var mm = String(v.title).match(/(\d+)\D+(\d+)/);
if (mm) steps.push({ from: +mm[1], to: +mm[2], cents: v.price, id: v.id });
});
if (z.name && steps.length) logoSizes.push({ name: z.name, steps: steps });
});
var logoSetup = cfg.logoSetup && cfg.logoSetup.id ? cfg.logoSetup : null;
function logoStep(size, q) { var r = null; size.steps.forEach(function (x) { if (q >= x.from && q <= x.to) r = x; }); return r; }
var tiers = [];
String(cfg.tiers || '').split(/[\n;]+/).forEach(function (l) {
var mt = l.match(/(\d+)\D+(\d+(?:[.,]\d+)?)/);
if (mt) tiers.push({ qty: +mt[1], pct: parseFloat(mt[2].replace(',', '.')) });
});
tiers.sort(function (a, b) { return a.qty - b.qty; });
function tierFor(q) { var t = null; tiers.forEach(function (x) { if (q >= x.qty) t = x; }); return t; }
function pctTxt(p) { return String(p).replace('.', ',') + '%'; }
var money;
try { money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cfg.currency || 'EUR' }); }
catch (err) { money = { format: function (v) { return '€ ' + v.toFixed(2).replace('.', ','); } }; }
function fmt(c) { return money.format(c / 100); }
var pid = 'sfc-' + (cfg.id || 'x') + '-';
if (!models.length) {
root.innerHTML = '<p class="sfc-empty">Nog geen modellen. Kies in de thema-editor een collectie of voeg een blok “Model” toe.</p>';
return;
}
var minQty = Math.max(1, parseInt(cfg.minQty, 10) || 1);
var MAXFILE = 10 * 1024 * 1024;
var st = { m: 0, v: 0, qty: minQty, busy: false, logoSize: null };
var h = '<div class="sfc-wrap"><div class="sfc-stage"><div class="sfc-art"></div>' +
'<div class="sfc-caption"><strong class="sfc-cap-title"></strong><span class="sfc-cap-sub"></span></div>' +
'<p class="sfc-fine">Illustratie ter indicatie. Kleur en model kunnen licht afwijken.</p></div>' +
'<div class="sfc-steps">';
if (cfg.heading || cfg.intro) {
h += '<header class="sfc-head">' + (cfg.heading ? '<h2>' + esc(cfg.heading) + '</h2>' : '') + (cfg.intro ? '<p>' + esc(cfg.intro) + '</p>' : '') + '</header>';
}
h += '<section class="sfc-step"><h3><span class="sfc-n">1</span>Kies uw model</h3><div class="sfc-models">';
models.forEach(function (m, i) {
var low = Math.min.apply(null, m.variants.map(function (v) { return v.price; }));
h += '<button type="button" class="sfc-model" id="' + pid + 'm' + i + '" data-m="' + i + '" aria-pressed="false">' +
'<span class="sfc-model-art"></span><span class="sfc-model-t">' + esc(m.title) + '</span>' +
'<span class="sfc-model-p">' + fmt(low) + '</span></button>';
});
h += '</div></section>';
h += '<section class="sfc-step"><h3><span class="sfc-n">2</span>Kies kleur of stof<span class="sfc-picked"></span></h3><div class="sfc-colors"></div></section>';
function extraHTML(e) {
var price = e.variantId ? '+ ' + fmt(e.price) : esc(e.priceLabel), isLogo = e.effect === 'logo';
var isCol = e.effect === 'garen' || e.effect === 'baan';
var x = '<div class="sfc-extra" data-e="' + e.i + '"><label class="sfc-extra-row" for="' + pid + 'e' + e.i + '">' +
'<input type="checkbox" id="' + pid + 'e' + e.i + '" data-e="' + e.i + '">' +
'<span class="sfc-extra-b"><span class="sfc-extra-t">' + esc(e.title) + '</span>' +
(e.text ? '<span class="sfc-extra-d">' + esc(e.text) + '</span>' : '') + '</span>' +
'<span class="sfc-extra-p">' + price + '</span></label>';
if (e.askText || e.askFile || isLogo || isCol) {
x += '<div class="sfc-extra-f" hidden>';
if (isCol) {
x += '<label>Kies de kleur: <span class="sfc-cc-n"></span></label><div class="sfc-cc" style="display:flex;flex-wrap:wrap;gap:.3rem">';
CC.forEach(function (cn, ci) {
x += '<button type="button" class="sfc-color" style="width:2.3rem;height:2.3rem" data-ce="' + e.i + '" data-c="' + ci + '" aria-pressed="false" aria-label="' + esc(cn) + '">' +
swatchSVG(fabricFor(cn)) + '</button>';
});
x += '</div>';
}
if (isLogo && logoSizes.length) {
x += '<label for="' + pid + 'ls">Formaat en plaats</label><select id="' + pid + 'ls" data-ls="1">';
logoSizes.forEach(function (z, zi) { x += '<option value="' + zi + '">' + esc(z.name) + '</option>'; });
x += '</select><span class="sfc-logo-info"></span>';
}
if (e.askFile) {
x += '<label for="' + pid + 'f' + e.i + '">' + esc(e.fileLabel) + '</label>' +
'<input type="file" id="' + pid + 'f' + e.i + '" data-f="' + e.i + '" accept=".png,.jpg,.jpeg,.svg,.webp,.pdf,.ai,.eps">' +
'<span class="sfc-file-err" hidden></span>';
}
if (e.askText) {
x += '<label for="' + pid + 'x' + e.i + '">' + esc(e.textLabel) + '</label>' +
'<input type="text" id="' + pid + 'x' + e.i + '" data-x="' + e.i + '" maxlength="' + (isLogo ? 28 : 120) + '" autocomplete="off">';
}
if (isLogo) {
x += '<label for="' + pid + 'n' + e.i + '">Opmerkingen bij het borduren</label>' +
'<textarea id="' + pid + 'n' + e.i + '" data-n="' + e.i + '" maxlength="500" rows="3" style="font:inherit;color:inherit;background:var(--sfc-panel);' +
'border:1px solid var(--sfc-line);border-radius:4px;padding:.5rem .6rem;width:100%;min-width:0;resize:vertical"></textarea>';
}
x += '</div>';
}
return x + '</div>';
}
var plain = extras.filter(function (e) { return e.effect !== 'logo'; });
var logos = extras.filter(function (e) { return e.effect === 'logo'; });
var stepNo = 2;
if (plain.length) {
h += '<section class="sfc-step"><h3><span class="sfc-n">' + (++stepNo) + '</span>Voeg extra’s toe</h3><div class="sfc-extras">';
plain.forEach(function (e) { h += extraHTML(e); });
h += '</div><p class="sfc-fine sfc-none" hidden>Voor dit model zijn geen extra’s beschikbaar.</p></section>';
}
if (logos.length) {
h += '<section class="sfc-step sfc-logo-step"><h3><span class="sfc-n">' + (++stepNo) + '</span>Borduren</h3><div class="sfc-extras">';
logos.forEach(function (e) { h += extraHTML(e); });
h += '</div><p class="sfc-fine">U ontvangt altijd eerst een definitieve opzet ter goedkeuring. Pas daarna gaan wij produceren en borduren.</p></section>';
}
h += '<section class="sfc-step"><h3><span class="sfc-n">' + (++stepNo) + '</span>Aantal en bestellen</h3>' +
'<div class="sfc-order"><div class="sfc-qty"><label for="' + pid + 'q">Aantal<span class="sfc-min"></span></label><div class="sfc-qty-c">' +
'<button type="button" class="sfc-qb" data-q="-1" aria-label="Tien minder">−</button>' +
'<input type="number" id="' + pid + 'q" min="' + minQty + '" max="9999" step="1" value="' + minQty + '" inputmode="numeric">' +
'<button type="button" class="sfc-qb" data-q="1" aria-label="Tien meer">+</button></div></div>' +
'<dl class="sfc-sum"></dl></div>' +
(tiers.length ? '<div class="sfc-tiers"></div>' : '') +
'<button type="button" class="sfc-add">In winkelwagen</button>' +
'<div class="sfc-msg" role="status" aria-live="polite"></div>' +
(cfg.note ? '<p class="sfc-fine">' + esc(cfg.note) + '</p>' : '') + '</section></div></div>';
root.innerHTML = h;
var $ = function (s) { return root.querySelector(s); };
var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
function cur() { return models[st.m]; }
function vari() { return cur().variants[st.v]; }
function minQ() { return SHAPES[shapeOf(cur())].min || minQty; }
function applicable(e) {
var S0 = SHAPES[shapeOf(cur())], bib = S0.bib;
if (S0.plain) return e.effect === 'logo';
return e.applies === 'alle' || (e.applies === 'schort' && bib) || (e.applies === 'sloof' && !bib);
}
function active() { return extras.filter(function (e) { return e.on && applicable(e); }); }
function logoIdx() {
var S0 = SHAPES[shapeOf(cur())], mid = Math.min(1, logoSizes.length - 1);
if (st.logoSize != null && logoSizes[st.logoSize] && !(S0.noGroot && st.logoSize === 2)) return st.logoSize;
return S0.bib ? mid : logoSizes.length - 1;
}
function logoQuote() {
if (!logoSizes.length) return null;
var z = logoSizes[logoIdx()], stp = logoStep(z, st.qty);
var le = extras.filter(function (e) { return e.effect === 'logo'; })[0];
var textOnly = le && !le.file && String(le.value || '').trim() !== '';
return { size: z, step: stp, cents: stp ? stp.cents : 0, label: stp ? '+ ' + fmt(stp.cents) : 'op aanvraag', setup: stp && logoSetup && !textOnly ? logoSetup : null };
}
function colOf(e) { return e.color != null ? fabricFor(CC[e.color]).fill : ''; }
function eName(e) { return e.title + ((e.effect === 'garen' || e.effect === 'baan') && e.color != null ? ' (' + CC[e.color].toLowerCase() + ')' : ''); }
function effects() {
var o = {}, logo = '', img = '', gc = '', bc = '';
active().forEach(function (e) {
o[e.effect] = true;
if (e.effect === 'logo') { logo = e.value; img = e.img; }
if (e.effect === 'garen') gc = colOf(e);
if (e.effect === 'baan') bc = colOf(e);
});
return { map: o, logo: logo, img: img, garen: gc, baan: bc, place: logoSizes.length ? (['klein', 'middel', 'groot'][logoIdx()] || 'middel') : 'middel' };
}
function drawModels() {
var f = fabricFor(vari().title);
$$('.sfc-model').forEach(function (b, i) {
var m = models[i], on = i === st.m;
var has = m.variants.some(function (v) { return v.title === vari().title; });
b.setAttribute('aria-pressed', on ? 'true' : 'false');
b.querySelector('.sfc-model-art').innerHTML = apronSVG({ shape: shapeOf(m), fabric: has ? f : fabricFor(m.variants[0].title) });
});
}
function drawColors() {
var m = cur(), s = '';
m.variants.forEach(function (v, i) {
s += '<button type="button" class="sfc-color" data-v="' + i + '" aria-pressed="' + (i === st.v ? 'true' : 'false') +
'" title="' + esc(v.title) + '" aria-label="' + esc(v.title) + '">' + swatchSVG(fabricFor(v.title)) + '</button>';
});
$('.sfc-colors').innerHTML = s;
}
function drawExtras() {
var any = false;
$$('.sfc-extra').forEach(function (el) {
var e = extras[+el.getAttribute('data-e')], ok = applicable(e);
el.hidden = !ok; if (ok && e.effect !== 'logo') any = true;
var f = el.querySelector('.sfc-extra-f');
if (f) f.hidden = !e.on;
el.classList.toggle('is-on', e.on);
var cnm = el.querySelector('.sfc-cc-n'); if (cnm) cnm.textContent = e.color != null ? CC[e.color] : '';
[].slice.call(el.querySelectorAll('[data-c]')).forEach(function (cb) { cb.setAttribute('aria-pressed', +cb.getAttribute('data-c') === e.color ? 'true' : 'false'); });
});
var lst = $('.sfc-logo-step');
if (lst) lst.hidden = !extras.some(function (e) { return e.effect === 'logo' && applicable(e); });
var ls = $('#' + pid + 'ls');
if (ls) {
if (ls.options[2]) { ls.options[2].disabled = !!SHAPES[shapeOf(cur())].noGroot; ls.options[2].hidden = ls.options[2].disabled; }
ls.value = String(logoIdx());
}
var none = $('.sfc-none'); if (none) none.hidden = any;
}
function drawStage() {
var m = cur(), v = vari(), fx = effects();
$('.sfc-art').innerHTML = apronSVG({ shape: shapeOf(m), fabric: fabricFor(v.title), extras: fx.map, logoText: fx.logo, logoImg: fx.img, logoPlace: fx.place, garenColor: fx.garen, baanColor: fx.baan,
label: m.title + ', ' + v.title });
$('.sfc-cap-title').textContent = m.title;
var names = active().map(eName);
$('.sfc-cap-sub').textContent = v.title + (names.length ? ' · ' + names.join(' · ') : '');
var differ = m.variants.some(function (x) { return x.price !== v.price; });
$('.sfc-picked').textContent = v.title + (differ ? ' · ' + fmt(v.price) : '');
$$('.sfc-color[data-v]').forEach(function (b, i) { b.setAttribute('aria-pressed', i === st.v ? 'true' : 'false'); });
}
function drawSum() {
var v = vari(), unit = v.price, s = '<div><dt>' + esc(v.ptitle || cur().title) + ', ' + esc(v.title) + '</dt><dd>' + fmt(v.price) + '</dd></div>';
var lq = logoQuote(), logoOn = false;
active().forEach(function (e) {
unit += e.price;
var val = e.variantId ? fmt(e.price) : esc(e.priceLabel || '–');
if (e.effect === 'logo' && lq) { val = lq.step ? fmt(lq.cents) : 'op aanvraag'; logoOn = true; }
s += '<div><dt>' + esc(eName(e)) + '</dt><dd>' + val + '</dd></div>';
});
if (lq) {
extras.forEach(function (e) {
if (e.effect !== 'logo') return;
var pe = root.querySelector('.sfc-extra[data-e="' + e.i + '"] .sfc-extra-p'); if (pe) pe.textContent = lq.label;
});
var li = $('.sfc-logo-info');
if (li) li.textContent = lq.step ? fmt(lq.cents) + ' per stuk bij ' + st.qty + ' stuks' +
(lq.setup ? ', plus eenmalig ' + fmt(lq.setup.price) + ' aanmaakkosten voor uw logo' : (logoSetup ? ', zonder aanmaakkosten omdat u alleen een naam laat borduren' : '')) + '. Op borduren geldt geen staffelkorting.' :
'Bij dit aantal maken wij voor het borduren een prijs op aanvraag.';
}
var logoC = logoOn && lq.step ? lq.cents : 0, setupC = logoC && lq.setup ? lq.setup.price : 0;
var tier = tierFor(st.qty), gross = unit * st.qty, off = tier ? Math.round(gross * tier.pct / 100) : 0;
s += '<div class="sfc-sum-u"><dt>Per stuk</dt><dd>' + fmt(unit + logoC) + '</dd></div>';
if (tier) s += '<div class="sfc-sum-k"><dt>Staffelkorting ' + pctTxt(tier.pct) + '</dt><dd>− ' + fmt(off) + '</dd></div>';
if (setupC) s += '<div><dt>Eenmalige aanmaakkosten borduren</dt><dd>' + fmt(setupC) + '</dd></div>';
s += '<div class="sfc-sum-t"><dt>Totaal, ' + st.qty + (st.qty === 1 ? ' stuk' : ' stuks') + '</dt><dd>' + fmt(gross - off + logoC * st.qty + setupC) + '</dd></div>';
if (cfg.vatNote) s += '<div class="sfc-sum-v"><dt>' + esc(cfg.vatNote) + (logoOn && !lq.step ? '. Het borduren zit niet in dit totaal.' : '') + '</dt><dd></dd></div>';
$('.sfc-sum').innerHTML = s;
if (tiers.length) {
var th = '<strong>Staffelkorting</strong><ul>', next = null;
tiers.forEach(function (x) {
if (!next && st.qty < x.qty) next = x;
th += '<li' + (tier === x ? ' class="is-on"' : '') + '><span>Vanaf ' + x.qty + ' stuks</span><span>' + pctTxt(x.pct) + ' korting</span></li>';
});
th += '</ul><p class="sfc-fine">' + (next ? 'Nog ' + (next.qty - st.qty) + (next.qty - st.qty === 1 ? ' stuk' : ' stuks') + ' voor ' + pctTxt(next.pct) + ' korting. ' : '') +
'De korting telt over alle schorten en sloven in uw bestelling en wordt in de winkelwagen verrekend.</p>';
$('.sfc-tiers').innerHTML = th;
}
}
function refresh(all) {
if (all) { drawColors(); drawExtras(); }
var mq = minQ(), qi = $('#' + pid + 'q'), ml = $('.sfc-min');
if (st.qty < mq) st.qty = mq;
if (qi) { qi.min = mq; qi.value = st.qty; }
if (ml) ml.textContent = mq > 1 ? ' (minimaal ' + mq + ')' : '';
drawModels(); drawStage(); drawSum();
$('.sfc-msg').innerHTML = '';
}
root.addEventListener('click', function (ev) {
var b = ev.target.closest('button'); if (!b || !root.contains(b)) return;
if (b.hasAttribute('data-c')) {
extras[+b.getAttribute('data-ce')].color = +b.getAttribute('data-c'); drawExtras(); drawStage(); drawSum();
} else if (b.hasAttribute('data-m')) {
var keep = vari().title; st.m = +b.getAttribute('data-m'); st.v = 0;
cur().variants.forEach(function (v, i) { if (v.title === keep) st.v = i; });
refresh(true);
} else if (b.hasAttribute('data-v')) {
st.v = +b.getAttribute('data-v'); refresh(false);
} else if (b.hasAttribute('data-q')) {
st.qty = Math.max(minQ(), Math.min(9999, +b.getAttribute('data-q') > 0 ? (Math.floor(st.qty / 10) + 1) * 10 : (Math.ceil(st.qty / 10) - 1) * 10));
$('#' + pid + 'q').value = st.qty; drawSum();
} else if (b.classList.contains('sfc-add')) {
add();
}
});
root.addEventListener('change', function (ev) {
var t = ev.target;
if (t.hasAttribute('data-ls')) { st.logoSize = +t.value; drawStage(); drawSum(); return; }
if (t.hasAttribute('data-f')) {
var fe = extras[+t.getAttribute('data-f')], file = t.files && t.files[0], err = t.parentNode.querySelector('.sfc-file-err');
fe.file = null; fe.img = ''; err.hidden = true;
if (file && file.size > MAXFILE) {
t.value = ''; err.textContent = 'Dit bestand is groter dan 10 MB. Kies een kleiner bestand.'; err.hidden = false;
} else if (file) {
fe.file = file;
if (/^image\//.test(file.type) && window.FileReader) {
var rd = new FileReader();
rd.onload = function () { if (fe.file === file) { fe.img = String(rd.result || ''); drawStage(); } };
rd.readAsDataURL(file);
}
}
drawStage(); drawSum();
return;
}
if (t.hasAttribute('data-e')) {
var ce = extras[+t.getAttribute('data-e')]; ce.on = t.checked;
if (ce.on && ce.color == null && (ce.effect === 'garen' || ce.effect === 'baan')) {
var cf = fabricFor(vari().title).fill, pref = [4, 0, 1, 3];
ce.color = pref.filter(function (ci) { return fabricFor(CC[ci]).fill !== cf; })[0];
}
if (ce.on && ce.group) extras.forEach(function (o) {
if (o !== ce && o.group === ce.group && o.on) { o.on = false; var ob = $('#' + pid + 'e' + o.i); if (ob) ob.checked = false; }
}); drawExtras(); drawStage(); drawSum(); $('.sfc-msg').innerHTML = '';
}
});
root.addEventListener('input', function (ev) {
var t = ev.target;
if (t.hasAttribute('data-x')) { extras[+t.getAttribute('data-x')].value = t.value; drawStage(); drawSum(); }
else if (t.hasAttribute('data-n')) { extras[+t.getAttribute('data-n')].note = t.value; }
else if (t.id === pid + 'q') { var q = parseInt(t.value, 10); st.qty = isNaN(q) || q < minQ() ? minQ() : Math.min(9999, q); drawSum(); }
});
root.addEventListener('focusout', function (ev) { if (ev.target.id === pid + 'q') ev.target.value = st.qty; });
function lines() {
var m = cur(), v = vari(), act = active(), key = Date.now().toString(36);
var props = {};
if (act.length) props["Extra's"] = act.map(eName).join(', ');
act.forEach(function (e) {
if (e.askText && e.value.trim()) props[e.title] = e.value.trim();
if (e.note && e.note.trim()) props['Opmerking borduren'] = e.note.trim();
});
var files = act.filter(function (e) { return e.askFile && e.file; });
var plabel = (v.ptitle || m.title) + ', ' + v.title;
if (logoSizes.length && act.some(function (e) { return e.effect === 'logo'; })) props['Logoformaat'] = logoSizes[logoIdx()].name;
props._samenstelling = key;
var items = [{ id: v.id, quantity: st.qty, properties: props, _label: plabel, _price: v.price, _files: files }];
act.forEach(function (e) {
if (e.variantId) items.push({ id: e.variantId, quantity: st.qty, properties: { 'Hoort bij': plabel, _samenstelling: key },
_label: eName(e), _price: e.price });
});
if (logoSizes.length && act.some(function (e) { return e.effect === 'logo'; })) {
var lq = logoQuote();
if (lq.step) {
items.push({ id: lq.step.id, quantity: st.qty, properties: { 'Hoort bij': plabel, _samenstelling: key }, _label: 'Borduren, ' + lq.size.name, _price: lq.cents, _nodisc: true });
if (lq.setup) items.push({ id: lq.setup.id, quantity: 1, properties: {}, _label: 'Eenmalige aanmaakkosten borduren', _price: logoSetup.price, _nodisc: true, _once: true });
}
}
return items;
}
function add() {
if (st.busy) return;
var items = lines(), msg = $('.sfc-msg'), btn = $('.sfc-add');
if (cfg.demo) {
var s = '<div class="sfc-ok"><strong>Dit gaat naar de winkelwagen</strong><ul>';
items.forEach(function (it) {
s += '<li><span>' + it.quantity + ' × ' + esc(it._label) + '</span><span>' + fmt(it._price * it.quantity) + '</span></li>';
Object.keys(it.properties).forEach(function (kk) {
if (kk.charAt(0) !== '_') s += '<li class="sfc-prop"><span>' + esc(kk) + ': ' + esc(it.properties[kk]) + '</span></li>';
});
(it._files || []).forEach(function (fe) {
s += '<li class="sfc-prop"><span>' + esc(fe.title) + ', bestand: ' + esc(fe.file.name) + '</span></li>';
});
});
var dt = tierFor(st.qty);
if (dt) {
var sum = 0; items.forEach(function (it) { if (!it._nodisc) sum += it._price * it.quantity; });
s += '<li><span>Staffelkorting ' + pctTxt(dt.pct) + '</span><span>− ' + fmt(Math.round(sum * dt.pct / 100)) + '</span></li>';
}
msg.innerHTML = s + '</ul></div>';
return;
}
st.busy = true; btn.disabled = true; btn.textContent = 'Bezig met toevoegen…';
var url = (cfg.cartAddUrl || '/cart/add') + '.js';
function parse(r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }
function sendJson(list) {
if (!list.length) return Promise.resolve({ ok: true, j: {} });
return fetch(url, {
method: 'POST', credentials: 'same-origin',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: list.map(function (it) { return { id: it.id, quantity: it.quantity, properties: it.properties }; }) })
}).then(parse);
}
var main = items[0], job, pre = Promise.resolve();
if (items.some(function (it) { return it._once; })) {
pre = fetch((cfg.cartUrl || '/cart') + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
.then(function (r) { return r.json(); })
.then(function (c) {
var have = {}; (c.items || []).forEach(function (ci) { have[ci.variant_id] = 1; });
items = items.filter(function (it) { return !(it._once && have[it.id]); });
}).catch(function () {});
}
job = pre.then(function () {
if (main._files.length) {
var fd = new FormData();
fd.append('id', main.id); fd.append('quantity', main.quantity);
Object.keys(main.properties).forEach(function (kk) { fd.append('properties[' + kk + ']', main.properties[kk]); });
main._files.forEach(function (fe) { fd.append('properties[' + fe.title + ' bestand]', fe.file, fe.file.name); });
return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd }).then(parse)
.then(function (res) { return res.ok ? sendJson(items.slice(1)) : res; });
}
return sendJson(items);
});
job.then(function (res) {
st.busy = false; btn.disabled = false; btn.textContent = 'In winkelwagen';
if (!res.ok) {
msg.innerHTML = '<div class="sfc-err">Toevoegen is niet gelukt: ' + esc(res.j.description || res.j.message || 'onbekende fout') + '</div>';
return;
}
if (cfg.redirect !== false) { window.location.href = cfg.cartUrl || '/cart'; return; }
msg.innerHTML = '<div class="sfc-ok"><strong>Toegevoegd aan de winkelwagen.</strong> <a href="' + esc(cfg.cartUrl || '/cart') + '">Bekijk winkelwagen</a></div>';
}).catch(function () {
st.busy = false; btn.disabled = false; btn.textContent = 'In winkelwagen';
msg.innerHTML = '<div class="sfc-err">Toevoegen is niet gelukt. Controleer uw verbinding en probeer het opnieuw.</div>';
});
}
refresh(true);
};